import axios from "axios";
import { server } from "../server";

const getAuthHeader = () => {
  const token = localStorage.getItem("dbToken");
  return { Authorization: `Bearer ${token}` };
};

export const createOrganizationAPI = async (name, description) => {
  try {
    const response = await axios.post(
      `${server}/organization`,
      {
        name,
        description,
      },
      {
        headers: {
          ...getAuthHeader(),
          "Content-Type": "application/json",
          "accept": "*/*",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getOrganizationsAPI = async () => {
  try {
    const response = await axios.get(`${server}/organization`, {
      headers: {
        ...getAuthHeader(),
        "accept": "*/*",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteOrganizationAPI = async (id) => {
  try {
    const response = await axios.delete(`${server}/organization/${id}`, {
      headers: {
        ...getAuthHeader(),
        "accept": "*/*",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateOrganizationAPI = async (id, data) => {
  try {
    const response = await axios.put(`${server}/organization/${id}`, data, {
      headers: {
        ...getAuthHeader(),
        "Content-Type": "application/json",
        "accept": "*/*",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
